import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ZoneButton from './ZoneButton';
import ZoneButtonsWrapper from './ZoneButtonsWrapper';
import {
  getRelativeHeight,
  getRelativeWidth,
} from '../../components/CardReader/CardReader';

const ButtonABCD = styled(ZoneButton)`
  margin-top: 11%;
  width: 71%;
`;
const ButtonBCD = styled(ZoneButton)`
  margin-left: 17%;
  width: 54%;
`;

const ButtonDummy = styled(ZoneButton)`
  width: 0;
`;

const DownButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0%;
  top: ${getRelativeHeight(-220)};
  left: ${getRelativeHeight(0)};
  height: ${getRelativeHeight(88)};
  width: ${getRelativeWidth(390)};
`;

const DownButton = styled(ZoneButton)`
  height: ${getRelativeHeight(148)};
  width: ${getRelativeWidth(65)};
  cursor: pointer;
`;

const ZoneButtonsD = ({
  onClickZoneABCD,
  onClickZoneBCD,
  onClickDownButton,
}) => (
  <ZoneButtonsWrapper>
    <ButtonABCD onClick={onClickZoneABCD} />
    <ButtonBCD onClick={onClickZoneBCD} />
    <DownButtonWrapper>
      <ButtonDummy onClick={() => false} />
      <DownButton onClick={onClickDownButton} />
    </DownButtonWrapper>
  </ZoneButtonsWrapper>
);

ZoneButtonsD.propTypes = {
  onClickZoneABCD: PropTypes.func.isRequired,
  onClickZoneBCD: PropTypes.func.isRequired,
  onClickDownButton: PropTypes.func.isRequired,
};

export default ZoneButtonsD;
